import React, { useState } from 'react'

const SquareTabbar = ({ list, handler, classes }) => {
  const [currentTab, setCurrentTab] = useState(list[0])

  const innerhandler = (item) => {
    setCurrentTab(item)
    handler(item)
  }

  return (
    <nav className={'-mb-px inline-flex ' + classes} aria-label='Tabs'>
      {list.map((item) => {
        const isActive = currentTab === item
        return (
          <span
            key={item}
            onClick={() => innerhandler(item)}
            id={item}
            className={`mr-1 rounded-ds-sm border py-2 px-4 text-xs font-semibold cursor-pointer transition-colors duration-150 ${
              isActive
                ? 'border-ds-brand bg-white text-ds-brand'
                : 'border-gray-300 bg-white text-gray-700 hover:border-ds-brand hover:text-ds-brand'
            }`}
          >
            {item}
          </span>
        )
      })}
    </nav>
  )
}

export default React.memo(SquareTabbar)
